import BannerItem from "./BannerItem";
import BannerItemSkeleton from "./BannerItemSkeleton";
import type { AnyBanner, BannerSection } from "../../../services/webServices/banners/types";

type BannersCarouselProps = {
  section: BannerSection;
  title: string;
  items: AnyBanner[];
  isLoading: boolean;
  onEdit: (banner: AnyBanner, section: BannerSection) => void;
  onDelete: (uuid: string) => void;
};

export default function BannersCarousel({
  section,
  title,
  items,
  isLoading,
  onEdit,
  onDelete,
}: BannersCarouselProps) {
  return (
    <div className="relative w-full bg-white border rounded-2xl card-shadow py-6 mb-6">
      <div className="flex items-center justify-between px-6 mb-4">
        <h3 className="text-lg font-semibold text-gray-700">{title}</h3>
        <span className="text-xs text-gray-500">{items.length} بنر</span>
      </div>

      <div className="flex gap-4 overflow-x-auto pb-2 px-6">
        {isLoading ? (
          Array.from({ length: 3 }).map((_, i) => <BannerItemSkeleton key={i} />)
        ) : items.length === 0 ? (
          <p className="text-sm text-gray-500 whitespace-nowrap text-center py-4">
            بنری یافت نشد
          </p>
        ) : (
          items.map((banner) => (
            <BannerItem
              key={banner.uuid}
              banner={banner}
              onEdit={(b) => onEdit(b, section)}
              onDelete={onDelete}
            />
          ))
        )}
      </div>
    </div>
  );
}
